export default "__VITE_ASSET__282e47aa__"